module.exports = __webpack_public_path__ + "static/img/zhangshufeng.85655f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/zhangshufeng.jpg
// module id = ld48
// module chunks = 1